// PAS UTILISE
import React, {useCallback, useEffect, useRef, useState} from 'react'
import Stack from '@mui/material/Stack';

import Item from './Item.js';
import { useSelector } from 'react-redux';
import { getTimerList, getPlayedGamesPeriods, getSurchargePeriod, getAllMatchPeriods } from '../../sports/rules.js';

const SelectTimer = ({onSelect, selected, match, activeState, surchargePeriod}) => {

    useEffect(() => {
        console.log('SelectTimer useEffect -- activeState.period: ' + activeState.period + ' , surchargePeriod: ' + surchargePeriod);
        activeState.period = activeState.period!== undefined ? activeState.period : surchargePeriod
    }, [])

    const [timers, setTimers] = useState([])

    const [selectedPeriod, setSelectedPeriod] = useState(activeState.period!==undefined ? activeState.period : surchargePeriod)

    const periodList = useCallback(() => {

        const itemsPeriod = []

        if(['handball'].includes(match.discipline)){

            const allPeriods = getAllMatchPeriods(match.discipline);
            const allPlayablePeriods = getPlayedGamesPeriods(match.discipline);
            const periodsToDisplay = new Map();

            for (const [key, value] of allPlayablePeriods) {
                if (key <= match.period) {
                    periodsToDisplay.set(value.matchPeriod, value);
                } else {
                    if (!allPeriods.get(match.period).isPlayable){
                        periodsToDisplay.set(value.matchPeriod, value);
                    }
                    break;
                }
            }

           for (const [matchPeriod, period] of periodsToDisplay) {
            itemsPeriod.push(<Item selected={selectedPeriod} onSelect={(e) => {setSelectedPeriod(e); activeState.period = e}} value={`${period.name}`} id={period.matchPeriod}/>)
           }


        }else{
            //Other disciplines
            for(var i = 0; i <= match.period ; i++){
                let actualInLoop = i
                if(i !== 2)
                    itemsPeriod.push(<Item selected={selectedPeriod} onSelect={(e) => {setSelectedPeriod(e); activeState.period = e}} value={`${"Periode "+ (actualInLoop <= 2 ? actualInLoop+1 : actualInLoop)}`} id={actualInLoop}/>)
            }
        }

        return itemsPeriod

    }, [match.period, selectedPeriod])

    const stackList = useRef();

    useEffect(() => {

        let realTimer = (activeState && activeState.timer !== undefined) ? activeState.timer : match.timer

        let periodValue = selectedPeriod;

        if (match.discipline==='handball' && !periodValue){
           const nextPer = getSurchargePeriod(match.discipline, match.period);
           periodValue = nextPer ? nextPer : match.period;
        }

        let min = 0
        let max = Math.max(60, realTimer+15)

        console.log('SelectTime.js getTimerList(periodValue, max, match.discipline) = ' + periodValue + ' ; ' + max + ' ; ' + match.discipline);
        let timerList = getTimerList(periodValue, max, match.discipline)
        setTimers(timerList)
    }, [, selectedPeriod])

    useEffect(() => {
        let stackScroll = stackList.current
        let totalHeight = stackScroll.offsetHeight

        let actualTime = Math.floor(match.timer / 60);
        let actualRatio = timers.map(t => t.id).indexOf(actualTime) * 100 / timers.length
        let actualScroll = totalHeight / 100 * actualRatio
        stackScroll.parentNode.scrollTop = actualScroll - (stackScroll.parentNode.offsetHeight / 2)

    }, [timers, selectedPeriod])

    return (
        <>
            <Stack spacing={1} direction="row" alignItems="center" justifyContent={"center"}>
                {periodList()}
            </Stack>
            <div style={{position: 'relative', overflow : 'auto', height : '200px', marginTop : '8px'}}>
                <Stack  spacing={2} alignItems="center" ref={stackList}>
                    {timers && timers.map(t => <Item selected={selected} onSelect={onSelect} value={`${t.value}'`} id={t.id}/>)}
                </Stack>
            </div>
            
        </>
    )
}

export default SelectTimer